import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import AffiliateDisclosure from "@/components/AffiliateDisclosure";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "This placeholder Privacy Policy explains, in plain terms, how DuckTheBugs handles the information you share. It should be reviewed by a qualified professional before launch.",
    sections: [
      { h: "Information we collect", p: "When you submit a Find-a-Pro request or newsletter sign-up, we collect the details you provide — such as your name, contact information, ZIP code, and a description of your pest issue. We may also collect basic technical and attribution data (for example, the page you came from) to understand how people use the site." },
      { h: "How we use it", p: "We use your information to respond to your request, to help connect you with an appropriate independent pest-control provider, and to improve our content and service. We do not sell your personal information." },
      { h: "Sharing with providers", p: "If you submit a service request, you understand that we may share the relevant details with an independent local provider so they can follow up. DuckTheBugs does not itself perform pesticide applications." },
      { h: "Your choices", p: "You can opt out of communications at any time. To request access to or deletion of your information, contact us using the details in the site footer." },
      { h: "Analytics", p: "We may use privacy-conscious analytics tools to understand aggregate usage. Any such tools will be configured in line with applicable requirements." },
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "This placeholder Terms of Use governs your use of DuckTheBugs. It should be reviewed by a qualified professional before launch.",
    sections: [
      { h: "Educational information only", p: "Content on DuckTheBugs is general educational information. It is not professional, medical, legal, or pest-management advice for your specific situation. Always follow product labels, manufacturer instructions, and applicable laws, and consult an appropriately licensed professional where required." },
      { h: "No treatment services", p: "DuckTheBugs provides educational information and may connect consumers with independent service providers. DuckTheBugs does not currently perform pesticide applications and is not responsible for the services performed by independent providers." },
      { h: "Service matching", p: "When you submit a request, we may connect you with an independent provider. We do not guarantee the availability, pricing, quality, or outcome of any provider's services." },
      { h: "No guarantees", p: "We work to keep information accurate and useful, but we make no guarantees about completeness or results. Use of the site is at your own discretion." },
      { h: "Changes", p: "We may update these terms from time to time. Continued use of the site indicates acceptance of the current terms." },
    ],
  },
  affiliate: {
    title: "Affiliate Disclosure",
    intro: "Transparency matters to us. Here's exactly how recommendations and any future affiliate relationships work.",
    sections: [
      { h: "How recommendations are made", p: "Product recommendations on DuckTheBugs are based on usefulness and relevance to homeowners — not on commission size. Where we suggest a category of product, our goal is to help you solve the problem, including with free or non-chemical options where those make sense." },
      { h: "Affiliate relationships", p: "In the future, some links on DuckTheBugs may be affiliate links, meaning we could earn a commission from qualifying purchases at no additional cost to you. When that's active, it will be disclosed clearly." },
      { h: "Our commitment", p: "A recommendation being an affiliate link never changes our editorial judgment. If the best answer for your situation is to do nothing, dump a flowerpot, or call a pro, that's what we'll say." },
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type] || CONTENT.privacy;
  return (
    <div data-testid={`legal-page-${type}`}>
      <Seo title={c.title} description={c.intro} path={`/${type === "affiliate" ? "affiliate-disclosure" : type}`} />
      <section className="bg-forest-950 text-cream grain pt-[72px]">
        <div className="relative max-w-3xl mx-auto px-4 sm:px-8 lg:px-12 py-14 md:py-20">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: c.title }]} />
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl font-black leading-[1.05]">{c.title}</h1>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12 py-14 md:py-16">
        <Reveal>
          <p className="text-lg text-forest-950/70 leading-relaxed">{c.intro}</p>
          {type === "affiliate" && (
            <div className="mt-6">
              <AffiliateDisclosure />
            </div>
          )}
          <div className="mt-10 space-y-8">
            {c.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-2xl font-bold text-forest-950">{s.h}</h2>
                <p className="mt-2 text-[17px] leading-relaxed text-forest-950/80">{s.p}</p>
              </div>
            ))}
          </div>
          <p className="mt-12 text-sm text-forest-950/50 italic">
            This is placeholder content provided for structure. Please have it reviewed by a qualified professional before publishing.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
